
<span [hidden]="hideLink"  class="d-inline-block text-logo-blue cursor-pointer lH-12 text-underline"> 
    View
 </span>